

























































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import Region from "../../store/entities/booking/region";
import Ajax from "../../lib/ajax";
import SinglePicture from "../../components/single-picture.vue";
@Component({
    components: { SinglePicture },
})
export default class EditRegion extends AbpBase {
    @Prop({ type: Boolean, default: false }) value: boolean;
    @Prop({ type: Object }) editRegion;
    region: Region = new Region();
    async save() {
        console.log(this.region, "region");
        (this.$refs.regionForm as any).validate(async (valid: boolean) => {
            if (valid) {
                await Ajax.put(
                    "/api/services/app/Region/Update",
                    this.region
                ).then((res) => {
                    (this.$refs.regionForm as any).resetFields();
                    this.$emit("save-success");
                    this.$emit("input", false);
                });
            }
        });
    }
    cancel() {
        (this.$refs.regionForm as any).resetFields();
        this.$emit("input", false);
    }
    visibleChange(value: boolean) {
        if (!value) {
            this.$emit("input", value);
        } else {
            this.region = Util.extend(true, {}, this.editRegion);
            this.region.icon = this.region.icon || "";
        }
    }
    regionRule = {
        name: [
            {
                required: true,
                message: this.L(
                    "FieldIsRequired",
                    undefined,
                    this.L("RegionName")
                ),
                trigger: "blur",
            },
            {
                type: "string",
                max: 256,
                message: this.L(
                    "NoMoreThenLength",
                    undefined,
                    this.L("RegionName"),
                    "256"
                ),
                trigger: "blur",
            },
        ],
        //  displayOrder: [{
        //     required: true,
        //     message: '请输入显示排序',
        //     trigger: "blur",
        //     type: "number"
        // }],
    };
}
